






























import { defineComponent, onMounted, ref } from "@vue/composition-api";
import Page from "@/components/layout/page.vue";
import PageHeader from "@/components/navigation/page-header.vue";
import DataTable from "@/components/data/data-table.vue";
import { Feature } from "@/swagger/models";
import { DataTableConfig } from "@/components/data/data-table";
import { featureService } from "@/services/feature";

export default defineComponent({
    name: "features-table",
    props: {
        customerId: {
            type: Number,
            required: true,
        },
    },
    components: { Page, PageHeader, DataTable },
    setup(props, context) {
        const features = ref<Feature[]>([]);
        const loading = ref(true);

        onMounted(async () => await loadItems());

        const loadItems = async () => {
            try {
                loading.value = true;
                features.value = await featureService.find({ params: { customerId: props.customerId } });
                loading.value = false;
            } catch (e) {
                console.warn(e);
            } finally {
                loading.value = false;
            }
        };

        const tableConfig: DataTableConfig<Feature> = {
            clickItemCallback: () => {},
            items: features,
            fields: [
                {
                    label: "ID",
                    field: "id",
                    compact: true,
                },
                {
                    label: "Name",
                    field: "name",
                },
                {
                    label: "Status",
                    field: "enabled",
                },
                {
                    label: "Created",
                    field: "createdAt",
                    compact: true,
                },
                {
                    label: "Updated",
                    field: "updatedAt",
                    compact: true,
                },
            ],
        };

        return { tableConfig, loading };
    },
});
